<template>
  <div class='wrapper-page'>
    <modal ref='filtersModal' class="filter-all-messages">
      <template #header>
        <h5 class='modal-title mt-0'>
          {{ $t('shared.filter') }}
        </h5>
      </template>

      <template #body>
        <form @submit.prevent='filterAttachments()'>
          <div class='modal-body'>
            <div class='form-group form-inline star-group'>
              <label>{{ $t('folders_list.starred_folders')}}</label>
              <label>
                <input type='radio' v-model='starred' value='true'>
                {{ $t('folders_list.yes_way') }}
              </label>

              <label>
                <input type='radio' v-model='starred' value='false'>
                {{ $t('folders_list.no_way') }}
              </label>
              <label>
                <i class='fas fa-times' :title="$t('records_list.remove_selection')" @click.prevent='starred = null'></i>
              </label>
            </div>
            <div class="form-group">
              <label>{{ $t('communication.received_from_contact') }}</label>
              <multi-select :getter="getContacts" v-model="fromContactsFilters" />
            </div>
            <div class="form-group form-inline">
              <label>{{ $t('communication.file_format') }}</label>
              <label><input type="checkbox" name="mimes[]" v-model="mimes" value="pdf" />PDF</label>
              <label><input type="checkbox" name="mimes[]" v-model="mimes" value="images" />Images</label>
              <label><input type="checkbox" name="mimes[]" v-model="mimes" value="docx" />Word Document</label>
              <label><input type="checkbox" name="mimes[]" v-model="mimes" value="xlsx" />Excel Document</label>
              <label><input type="checkbox" name="mimes[]" v-model="mimes" value="csv" />CSV</label>
            </div>
            <div class="form-group">
              <label>{{ $t('communication.received_date') }}</label>
              <div class="date">
                <label>{{ $t('communication.from') }}</label>
                <datepicker
                  ref="datepicker"
                  name="document_response[created_date]"
                  v-model="fromReceivedDate"
                  input-class="form-control expiration-input"
                  :inline="false"
                  :typeable="true"
                  :full-month-name="true"
                  :monday-first="true"
                  :placeholder="$t('expiration.pick_date')">
                </datepicker>
              </div>
              <div class="date">
                <label>{{ $t('communication.to') }}</label>
                <datepicker
                  ref="datepicker"
                  name="document_response[created_at]"
                  v-model="toReceivedDate"
                  input-class="form-control expiration-input"
                  :inline="false"
                  :typeable="true"
                  :full-month-name="true"
                  :monday-first="true"
                  @selected="this.$refs.datepicker.close()"
                  :placeholder="$t('expiration.pick_date')">
                </datepicker>
              </div>
            </div>
          </div>

          <div class='modal-footer'>
            <input type='reset' class='btn btn-neutral float-right' :value="$t('folders_list.clear_filters')" @click.prevent='resetFilters' />
            <input type='submit' class='btn btn-outline-primary float-right' :value="$t('folders_list.filter')" />
          </div>
        </form>
      </template>
    </modal>
    <div class='container-fluid text-center'>
      <h1 class='page-title'>
        {{ $t('communication.attachments') }} ({{meta.total}})
        <a :href="attachVideo()" target="_blank" class="own-tooltip own-tooltip-bottom video-link" :data-tooltip="$t('communication.click_here_to_watch_attach')"><img src="../../assets/video.svg" /></a>
      </h1>
      <div class='filter'>
        <a  @click.prevent="openModal($refs.filtersModal)" href="#" class="filter-by btn btn-neutral">
          {{ $t('root.filter_all_data_by') }}
        </a>
      </div>
      <div class="filter-results" v-if="filterAttachments">
        <strong v-if="hasFilters">{{ $t('root.filter_results_for') }}</strong>
        <div v-if="starred !== null">
          <p>{{ $t('root.filters.starred') }}
            <strong v-if="starred === 'true'">{{ $t('root.filters.yes_way') }}</strong>
            <strong v-if="starred === 'false'">{{ $t('root.filters.no_way') }}</strong>
          </p>
        </div>
        <div v-if="fromContactsFilters.length > 0">
          <p>{{ $t('communication.filters.from') }} <strong v-for="contact in fromContactsFilters">{{contact.email}} - {{contact.company}}</strong></p>
        </div>
        <div v-if="fromReceivedDate !== null">
          <p>{{ $t('communication.filters.receiving_date') }} <strong>{{formatDate(fromReceivedDate)}}</strong></p>
        </div>
        <div v-if="toReceivedDate !== null">
          <p>{{ $t('communication.filters.until_date') }} <strong>{{formatDate(toReceivedDate)}}</strong></p>
        </div>
        <div v-if="mimes.length > 0">
          <p>{{ $t('communication.file_format') }} <strong v-for="mime in mimes">{{ mime }}</strong></p>
        </div>
        <a v-if="hasFilters" @click.prevent="resetFilters" href="#">{{ $t('records_list.clear_filters') }}</a>
      </div>
      <loading v-if="loading" class="m-t-60" />
      <div v-if='attachments.length === 0 && !loading' class="empty-list-wrapper">
        <img src="../../assets/empty_states/records.png" />
        <p>{{$t('communication.attachments_empty_state')}}</p>
      </div>
      <div class="table_wrapper" v-else-if='attachments.length > 0 && !loading'>
        <table class="table">
          <thead>
            <tr>
              <th></th>
              <th>{{ $t('communication.file_name') }}</th>
              <th>{{ $t('communication.received_from') }}</th>
              <th>{{ $t('communication.received_on') }}</th>
              <th>{{ $t('communication.version') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="attachment in attachments">
              <td class="data-img">
                <img :src="mimeToSrc(attachment.mime_type)" />
              </td>
              <td>
                <router-link :to="{ name: 'record', params: { id: attachment.current_version.id, propRecords: attachments } }">
                  {{ attachment.filename }}
                </router-link>
                <a href='#' class="starred" @click.prevent="toggleStar(attachment)">
                  <i :class="['fa-star', {'far': !attachment.starred, 'fas': attachment.starred }]"></i>
                </a>
              </td>
              <td>
                {{ attachment.document_response.contact.name }}
              </td>
              <td>{{ `${formatDate(attachment.document_response.created_at)} ${formatTime(attachment.document_response.created_at)}` }}</td>
              <td>
                <strong class="version-no" v-if="attachment.current_version">
                  <span v-if="attachment.current_version.version != '1'">{{$t('communication.not_current')}}</span>
                {{ `V${attachment.current_version.version}` }}
                <span v-if='attachment.next_record_id == null'>{{$t('versions.current')}}</span>
                </strong>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <pagination :meta='meta'/>
    </div>
  </div>
</template>

<script>
import _modal from '../../components/_modal'
import _pagination from "../../components/_pagination"
import _loading from '../../components/_loading'
import _multi_select from "../../components/shared/_infinite_multi_select"
import Datepicker from 'vuejs-datepicker'

export default {
  name: 'Attachments',
  components: {
    'modal': _modal,
    pagination: _pagination,
    'loading': _loading,
    'multi-select': _multi_select,
    'datepicker': Datepicker
  },
  data() {
    return {
      loading: true,
      fromContactsFilters: [],
      fromReceivedDate: null,
      toReceivedDate: null,
      mimes: [],
      starred: null,
    }
  },
  watch: {
    query() {
      this.getAttachments()
    }
  },
  created() {
    this.getAttachments()
    this.store.sendMetrics({name: 'attachments', params: this.$route.params, path: this.$route.fullPath})
  },
  computed: {
    attachments() {
      return this.state.attachments || []
    },
  },
  methods: {
    getAttachments() {
      this.store.getAttachments(this.query).then(() =>  this.loading = false)
    },
    openModal(modal) {
      modal.open()
    },
    filtersOn() {
      this.$refs.filtersModal.close()
    },
    getContacts(params) {
      return this.listStore.getContacts(params)
    },
    resetFilters() {
      this.fromContactsFilters = []
      this.fromReceivedDate = null
      this.toReceivedDate = null
      this.starred = null
      this.mimes = []
      this.$router.push({ query: null})
      this.$refs.filtersModal.close()
    },
    filterAttachments() {
      let q  = {
        'filters[contacts]': this.fromContactsFilters.length > 0 ? this.fromContactsFilters.map(c => c.id) : null,
        'filters[from_received_date]': this.fromReceivedDate !== null ? this.formatDate(this.fromReceivedDate) : null,
        'filters[to_received_date]': this.toReceivedDate !== null ? this.formatDate(this.toReceivedDate) : null,
        'filters[mimes]': this.mimes.length > 0 ? this.mimes : null,
        'filters[starred]': this.starred !== null ? this.starred : null,
        'page': this.query.page || 1
      }
      const f = Object.entries(q).reduce((a,[k,v]) => (v === null ? a : (a[k]= v, a)), {})

      this.$refs.filtersModal.close()
      this.$router.push({ query: f })
    },
    toggleStar(attachment) {
      let promise = null
      promise = this.store.updateRecord(attachment, { starred: !attachment.starred })
      this.store.sendMetrics({name: 'toggle_record_star', params: this.$route.params, path: this.$route.fullPath})

      promise.then(() => this.getAttachments())
    },
    attachVideo(){
      if(this.locale === 'de')
        return 'https://relatico.wistia.com/medias/csux2ij0c8'
      return 'https://relatico.wistia.com/medias/x581lovgvy'
    }
  },
}
</script>

<style lang="sass" scoped>
  .filter
    clear: both
  form
    text-align: left
    label
      text-align: left
      display: block
    .form-group
      margin-bottom: 20px
      .date
        width: 47%
        display: inline-block
        margin-right: 10px
    .form-inline
      label
        width: 50%
        margin-bottom: 10px
        &:first-child
          width: 100%
        input
          margin-right: 10px
      &.star-group
        label
          width: 20%
          &:first-child
            width: 50%
          &:last-child
            width: 5%
            color: #686868
            cursor: pointer
  .version-no
    border: 1px solid #51be8f
    border-radius: 5px
    color: #51be8f
    font-size: 12px
    font-weight: 400
    padding: 2px 3px
    text-align: center
    display: inline-block
    letter-spacing: normal
</style>
